export const SET_EMAIL_FIELD_DATA = 'Widget::SubscribeForm::Set::EmailField';
export const TOOGLE_AGREEMENT_FIELD_DATA = 'Widget::SubscribeForm::Toogle::AgreementField';

export const SUBSCRIBE_URL = '/shop/basket/subscribe/';

/* Form possible states constants */
export const SUBSCRIBE_FORM_STATE_INIT = 'Initial';
export const SUBSCRIBE_FORM_STATE_SUCCESS = 'Success';
export const SUBSCRIBE_FORM_STATE_ERROR = 'Error';
export const SUBSCRIBE_FORM_STATE_ALREADY = 'AlreadySubscribed';

export const SUBSCRIBE_FORM_FIELD_EMAIL = 'EmailField';
export const SUBSCRIBE_FORM_FIELD_AGREEMENT = 'AgreementField';
export const SUBSCRIBE_FORM_NAME = 'SubscribeForm';
